import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import vmwareService from "services/admin/masters/vmwareService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import {getMatrixId} from "utils/matriceHelpers";
import {
  MAPPING_SELECT_ERROR_TEMPLATE,
  MSG_MAPPING_DELETE_WARNING,
  MSG_MAPPING_RESTORE_WARNING
} from "constants/admin/masters/vmware";
import { ERROR_MESSAGE_UNKNOWN, MSG_RECORD_CREATE, MSG_RECORD_DELETE, MSG_RECORD_UNDO_DELETE, MSG_RECORD_UPDATE } from "constants/common";


function ManageVmwareHba() {
  const Id  = getMatrixId(window.location.pathname);
  const [breadcrumbs, setBreadcrumbs] = useState([
    { title: "UCP Vmware Mapping Masters", url: "/admin/master/ucp-vmware/" },
    { title: "Manage Mapping" },
  ]);
  const serviceObj = new vmwareService();

  // form fields
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [selectedCombineKeys, setSelectedCombineKeys] = useState([]);
  const [hbaList, setHbaList] = useState([]);
  const [hbaDriverList, setHbaDriverList] = useState([]);
  const [selectedHbaDetails, setHbaDetails] = useState(null);
  const [hbaTableData, setHbaTableData] = useState([{}]);
  const [selectedHbaDriverDetails, setHbaDriverDetails] = useState(null);
  const [hbaIds, setHbaIds] = useState("");
  const [hbaFootnotes, setHbaFootnotes] = useState("");
  const [hbaDriveType, setHbaDriveType] = useState("");
  const [hbaFirmware, setHbaFirmware] = useState("");

  // other fields
  const [isEditForm, setEditForm] = useState(false);
  const [editableItem, setEditableItem] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [combineKeyError, setCombineKeyError] = useState('');
  const [warningType, setWarningType] = useState(null);
  const [hbaError, setHbaError] = useState('');
  const [hbaDriverError, setHbaDriverError] = useState('');

  useEffect(() => {
    getHbaData();
  }, []);
  // call api to get hba mapping page data
  const getHbaData = () => {
    serviceObj
      .getAllInitialData(Id)
      .then((response) => {

        let combineKeyList = response?.vmware_combine_keys;
        let list = combineKeyList.map((item) => {
          return {
            id: item.id,
            value: item.combine_key,
            label: item.combine_key,
          };
        });
        let hbaList = response?.hba_master_drop_list.map((item) => {
          return {
            id: item.id,
            value: item.name,
            label: item.name,
            isDisabled: item.disabled,
          };
        });

        let hbaDriverList = response?.hba_driver_master_drop_list.map((item) => {
          return {
            id: item.id,
            value: item.name,
            label: item.name,
            isDisabled: item.disabled,
          };
        });
        let tableData = response?.vmware_hba_mapping_list;
        setHbaTableData(tableData);

        setCombineKeyList(list);
        setHbaList(hbaList);
        setHbaDriverList(hbaDriverList);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };
  // multi select dropdown function
  const selectMultipleValue = (selectedValues) => {
    setSelectedCombineKeys(selectedValues);
  };
  const resetForm = () => {
    setSelectedCombineKeys([]);
    setHbaDetails(null);
    setEditForm(false);
    setEditableItem(null);
    setHbaFootnotes("");
    setHbaDriveType("");
    setHbaFirmware("");
    setEditForm("");
    setItemToBeDeleted(null);
    setIsFormTouched(false);
    setCombineKeyError("");
    setWarningType("");
    setHbaDriverError("");
    setWarningType(null);
    setHbaError("");
    setHbaDriverDetails(null);
    setHbaIds("")
  };
  // function to add new drive mapping
  const addHbaMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    // form fields data check validation
    const isFormValid = validateHbaForm();

    // // call POST api if form is valid
    if (isFormValid) {
      //form fields data
      let payload = {
        "vmware_combine_keys": selectedCombineKeys.map((key) => key.id),
        "hba_id": selectedHbaDetails.id,
        "hba_driver_id": selectedHbaDriverDetails.id,
        "hba_ids": hbaIds,
        "hba_footnotes": hbaFootnotes,
        "hba_driver_type": hbaDriveType,
        "hba_firmware": hbaFirmware,
      }
      // api call
      serviceObj.createHbaMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getHbaData();
        resetForm();
      });
    }
  };
  // validate fields and set or reset error message
  const validateHbaForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }

    if (!selectedHbaDetails?.value) {
      setHbaError(getErrorMessageFor("HBA"));
      isFormValid = false;
    } else {
      setHbaError("");
    }

    if (!selectedHbaDriverDetails?.value) {
      setHbaDriverError(getErrorMessageFor("HBA Driver"));
      isFormValid = false;
    } else {
      setHbaDriverError("");
    }
    return isFormValid;
  };
  // create error message based on field name 
  const getErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };
  // update drive
  const updateHbaMapping = (e) => {
    e.preventDefault();
    let data = {
      "vmware_combine_keys": selectedCombineKeys.map((key) => key.id),
      "hba_id": selectedHbaDetails.id,
      "hba_driver_id": selectedHbaDriverDetails.id,
      "hba_ids": hbaIds,
      "hba_footnotes": hbaFootnotes,
      "hba_driver_type": hbaDriveType,
      "hba_firmware": hbaFirmware,
    }
    let ID = editableItem.record_details.id;
    serviceObj.updateHbaMapping(ID, data).then((response) => {
      toast.success(MSG_RECORD_UPDATE);
      getHbaData();
      resetForm();
    }).catch(error => toast.error(ERROR_MESSAGE_UNKNOWN))
  };
  // get edit item details from api call and store in state
  const editForm = (data) => {
    setEditForm(true);
    // call get api to get edit drive details.
    serviceObj.getHbaKeyDetails(data.id).then((response) => {
      // storing editable item details in local state for final edit api
      setEditableItem(response);
      let item = response?.record_details;
      let combineKeys = response?.vmware_combine_keys.map((item) => {
        return {
          id: item.id,
          value: item.combine_key,
          label: item.combine_key,
          isDisabled: true
        }

      })
      let hba = {
        id: item.hba_id,
        value: item.hba,
        label: item.hba,
      };

      let hbaDriver = {
        id: item.hba_driver_id,
        value: item.hba_driver,
        label: item.hba_driver
      }

      setSelectedCombineKeys(combineKeys);
      setHbaDetails(hba);
      setHbaDriverDetails(hbaDriver);
      setHbaFootnotes(item.hba_footnotes);
      setHbaDriveType(item.hba_driver_type);
      setHbaFirmware(item.hba_firmware);
      setHbaIds(item.hba_ids)
    })
  }
  // show delete warning confirmation popup
  const showWarning = (rowData) => {
    let type = rowData.is_deleted ? "restore" : "delete";
    setWarningType(type);
    let message = rowData.is_deleted ? MSG_MAPPING_RESTORE_WARNING : MSG_MAPPING_DELETE_WARNING;
    setConfirmMessage(message + rowData.hba + " ?");
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
  };
  // delete or restore selected drive
  const deleteHbaFunction = () => {
    let ID = itemToBeDeleted.id;
    // deleteDriveMapping is used for both delete and restore 
    serviceObj.deleteHbaMapping(ID)
      .then((response) => {
        let toastMessage = warningType === "restore" ? MSG_RECORD_UNDO_DELETE : MSG_RECORD_DELETE;
        toast.success(toastMessage);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getHbaData();
        setItemToBeDeleted(null);
      }).catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getHbaData();
        setItemToBeDeleted(null);
      })
  }
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  };
  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />
      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteHbaFunction}
          handleSubmit={deleteHbaFunction}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}

      {/* main form section */}
      <div className="form-group d-flex">
        <div className="col-sm-4">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                {/* combine key */}
                <label htmlFor={""} className="mr-sm-2 mt-2">
                  <b>VMware Combine Key</b>
                </label>
                <Select
                  isMulti
                  name="Combine Key"
                  options={combineKeyList}
                  classNamePrefix="select"
                  onChange={(e) => selectMultipleValue(e)}
                  value={selectedCombineKeys}
                  isSearchable={true}
                  isClearable={true}
                />
                {
                  combineKeyError
                  &&
                  <div className="col-sm-10 mb-2 text-danger">{combineKeyError}</div>
                }
                {/* HBA */}
                <label htmlFor={"Hba"} className="mr-sm-2 mt-2">
                  <b>HBA </b>
                </label>
                <div className="form-group">

                  <Select
                    name="hba"
                    options={hbaList}
                    classNamePrefix="Select"
                    onChange={(e) => setHbaDetails(e)}
                    value={selectedHbaDetails}
                    isDisabled={isEditForm}
                  />
                  {
                    hbaError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{hbaError}</div>
                  }
                </div>

                {/* HBA Driver */}
                <label htmlFor={"Hba"} className="mr-sm-2 mt-2">
                  <b>HBA Driver </b>
                </label>
                <div className="form-group">
                  <Select
                    name="hba driver"
                    options={hbaDriverList}
                    classNamePrefix="Select"
                    onChange={(e) => setHbaDriverDetails(e)}
                    value={selectedHbaDriverDetails}
                    isDisabled={false}
                  />
                  {
                    hbaDriverError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{hbaDriverError}</div>
                  }
                </div>
                {/* HBA IDs*/}
                <label htmlFor={"HBA IDs"} className="mr-sm-2 mt-2">
                  <b>HBA IDs </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="hba_ids"
                    value={hbaIds}
                    onChange={(e) => setHbaIds(e.target.value)}
                    disabled={selectedHbaDetails === null || selectedHbaDriverDetails === null}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"HBA Footnotes"} className="mr-sm-2 mt-2">
                  <b>HBA Footnotes</b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="hba Footnotes"
                    value={hbaFootnotes}
                    onChange={(e) => setHbaFootnotes(e.target.value)}
                    disabled={selectedHbaDetails === null || selectedHbaDriverDetails === null}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"HBA Driver Type"} className="mr-sm-2 mt-2">
                  <b>HBA Driver Type </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="hbaDriveType"
                    value={hbaDriveType}
                    onChange={(e) => setHbaDriveType(e.target.value)}
                    disabled={selectedHbaDetails === null || selectedHbaDriverDetails === null}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"HBA Firmware"} className="mr-sm-2 mt-2">
                  <b>HBA Firmware </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="HBA Firmware"
                    value={hbaFirmware}
                    onChange={(e) => setHbaFirmware(e.target.value)}
                    disabled={selectedHbaDetails === null || selectedHbaDriverDetails === null}
                    placeholder="Enter value"
                  />
                </div>
               
                
              </div>
            </div>

            <div className="col-sm-12">
              <button
                type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"
              >
                <i className="fa fa-refresh"></i> Reset
              </button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                // disabled={isSubmitting}
                onClick={isEditForm ? updateHbaMapping : addHbaMapping}
              >
                {isEditForm ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-8">
          <MaterialTable
            title="HBA Mappings"
            columns={[
              { title: "Combine Key", field: "vmware_combine_key" },
              { title: "HBA", field: "hba" },
              { title: "HBA Driver", field: "hba_driver" },
              { title: "HBA Ids", field: "hba_ids" },
              { title: "HBA Footnotes", field: "hba_footnotes" },
              { title: "HBA Driver Type", field: "hba_driver_type" },
              { title: "HBA Firmware", field: "hba_firmware" },
            ]}
            data={hbaTableData && hbaTableData}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400,
            }}
            localization={{
              header: {
                actions: "Actions",
              },

            }}
            actions={[
              (rowData) => ({
                icon: "edit",
                tooltip: !rowData.is_deleted && "Edit Record",
                onClick: (e, data) => {
                  // call edit function
                  editForm(data);
                },
                hidden: !rowData?.id || rowData.is_deleted// display action only if any valid item is present
              }),
              (rowData) => ({
                icon: rowData.is_deleted ? "undo" : "delete",
                tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                onClick: (e, data) => {
                  showWarning(data);
                },
                hidden: !rowData?.id // display action only if any valid item is present
              }),
            ]}
          />
        </div>
      </div>
      {/* form end */}
    </div>
  )
}

export default ManageVmwareHba